exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share-popover-panel{padding:15px;border:1px solid #e7e7e7}.share-popover-panel.exited{display:block;padding:0}.share-popover-panel-header{display:flex;justify-content:space-between;margin:10px;color:#468cc8;font-size:12px}", ""]);

// exports
